<template>
  <div style="height: 35vh; overflow-y: scroll; overflow-x: hidden;" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10" infinite-scroll-immediate-check="false">
    <b-row v-for="row in data"  class="my-1 py-1" style="cursor: pointer; min-height: 35px">
      <b-col cols="auto">
        <i class="fa fa-angle-right mr-2"></i>
      </b-col>
      <b-col cols="9">
        {{ row.content }}
      </b-col>
      <b-col cols="auto" v-if="row.createTime">
        {{ row.createTime | date }}
      </b-col>
    </b-row>
  </div>
</template>
<script type="text/javascript">
// import vuex from 'vuex'
import Vue from 'vue'
import infiniteScroll from 'vue-infinite-scroll'

export default {
  name: 'InfinityScrollList',
  components: {

  },
  directives: { infiniteScroll },
  data() {
    return {
      data: [],
      busy: false,
      currentPage: 0,
      perPage: 15
    }
  },
  props: {
    apiAction: {
      type: String,
      required: true
    },

    extra: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.$store.dispatch(
      this.apiAction, {
        count: this.perPage,
        page: this.currentPage + 1,
        ...this.extra
      }
    ).then((json) => {
      this.currentPage += 1;
      this.data.concat(json.list);
      this.data = json.list;
    }).catch((err) => {
      console.error(err);
    });
  },
  methods: {
    loadMore() {
      this.busy = true;
      this.$store.dispatch(
        this.apiAction, {
          count: this.perPage,
          page: this.currentPage + 1,
          ...this.extra
        }
      ).then((json) => {
        this.currentPage += 1;
        this.data.concat(json.list);
        let result = [
          ...this.data,
          ...json.list
        ];
        Vue.set(this, 'data', result);
        // console.log(this.data.length);
        this.busy = false;
      }).catch((err) => {
        console.error(err);
      });
    }
  }

}

</script>



// WEBPACK FOOTER //
// src/Homepage/components/Notification/components/InfinityScrollList.vue